import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BpValueChangeComponent } from "./bp-value-change.component";
import { CoreModule } from "@modules/core/core.module";

@NgModule({
	declarations: [BpValueChangeComponent],
	exports: [BpValueChangeComponent],
	imports: [CommonModule, CoreModule]
})
export class BpValueChangeModule {}
